"use strict";
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
export var actions = _7a468({ defaultClassName: "TreebeardHeader_actions__kjn0wc1", variantClassNames: { visible: { true: "TreebeardHeader_actions_visible_true__kjn0wc2" } }, defaultVariants: {}, compoundVariants: [] });
export var folder = "TreebeardHeader_folder__kjn0wc0";
export var input = "TreebeardHeader_input__kjn0wc4";
export var menuSpacer = "TreebeardHeader_menuSpacer__kjn0wc3";
